export default __webpack_public_path__ + "static/media/tableau-des-scores.591d50bf.svg";